<template>
  <div class="st-footer">
    <div class="st-bottom">
      <div class="st-bottom-left">
        <div class="st-bottom-name">{{ setInfo.name }}</div>
        <div class="st-bottom-nav">
          <ul>
            <li
              :class="{ activeli: $route.path === item.routeName }"
              v-for="item in $store.state.navList"
              :key="item.id"
              @click="changeNav(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
      <div class="st-bottom-right">
        <div>
          集团总部：{{ setInfo.mobile }} <br v-if="isMobile == 1" />
          邮箱：{{ setInfo.email }}
        </div>
        <div>公司地址：{{ setInfo.address }}</div>
        <div class="copy">{{ setInfo.copyRightMsg }} {{ setInfo.icpMsg }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { sysFriendLinkList } from "@/util/friendlink/friendlink";
import { searchwebConfig } from "@/util/set/set";
export default {
  data() {
    return {
      isMobile: sessionStorage.getItem("isMobile"),
      setInfo: {},
      friendLinkList: [],
    };
  },
  created() {
    // 友情链接数据
    sysFriendLinkList().then((res) => {
      if (res.code === 0) {
        this.friendLinkList = res.data;
      }
    });
    //配置信息
    searchwebConfig().then((res) => {
      if (res.code === 0) {
        this.setInfo = res.data;
      }
    });
  },
  methods: {
    changeNav(val) {
      this.$store.commit("SET_INFO", { code: val.code, name: val.name });
      this.$store.commit("SET_SUBLIST", { subList: val.children });
      window.scrollTo(0, 0);
      // 路由跳转
      if (val.routeName == this.$route.path) {
        this.reload();
      } else {
        this.$router.push(val.routeName);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@function pxToRem($args) {
  @return $args / 50 + rem;
}

.st-footer {
  width: 100%;
  height: 130px;
  background-color: #3f3f3f;
  color: #dcdbdb;

  .st-bottom {
    width: 70%;
    padding: 0 15%;
    height: 130px;
    overflow: hidden;
    .st-bottom-left {
      width: 60%;
      display: inline-block;
      .st-bottom-name {
        font-size: 30px;
        font-weight: bold;
        line-height: 30px;
        font-family: Microsoft YaHei;
        // float: left;
        // margin-right: 10%;
        margin-top: 30px;
        display: inline-block;
      }
      .st-bottom-nav {
        margin-top: 25px;
        ul {
          font-size: 14px;
          display: flex;
          flex-wrap: wrap;
          li {
            text-align: center;
            cursor: pointer;
            border-right: 1px solid #dcdbdb;
            padding: 0 20px;
            &:first-child {
              border-left: 1px solid #dcdbdb;
            }
            &:hover {
              color: $theme;
            }
          }
          .activeli {
            color: $theme;
          }
        }
      }
    }
    .st-bottom-right {
      width: 40%;
      font-size: 13px;
      color: #d8d6d6;
      line-height: 28px;
      float: right;
      text-align: right;
      margin-top: 30px;
    }
  }
  .st-record {
    background-color: #e5e6e1;
    text-align: center;
    line-height: 40px;
    font-size: 13px;
    color: #777777;
  }
}

@media (max-width: 1300px) {
  .st-footer .st-bottom .st-bottom-right,
  .st-footer .st-bottom .st-bottom-left {
    width: 50%;
  }
  .st-footer .st-bottom .st-bottom-left .st-bottom-nav ul li {
    padding: 0 10px;
  }
}
@media (max-width: 1024px) {
  .st-footer {
    height: fit-content;
    background-color: #3f3f3f;

    .st-bottom {
      width: 100%;
      height: fit-content;
      padding: 0 pxToRem(20);
      box-sizing: border-box;
      .st-bottom-left {
        width: 100%;
        display: block;

        .st-bottom-name {
          width: 100%;
          margin-bottom: pxToRem(15);
          padding-bottom: pxToRem(12);
          border-bottom: 1px solid #e1e7ec;
          color: #9da9b9;
          font-size: pxToRem(16);
          font-weight: 500;
          text-transform: uppercase;
        }
        .st-bottom-nav {
          display: none;
        }
      }
      .st-bottom-right {
        width: 100%;
        text-align: left;
        display: block;
        line-height: pxToRem(28);
        font-size: pxToRem(13);
        margin-top: pxToRem(10);

        .copy {
          text-align: center;
          padding: pxToRem(6) 0;
          margin-top: pxToRem(10);
          color: rgba(255, 255, 255, 0.5);
          border-top: 1px solid rgba(255, 255, 255, 0.12);
        }
      }
    }

    .st-footer-friendlink {
      line-height: 30px;
      width: 90%;
      padding: 0 5% 20px 5%;
      span {
        margin-right: 30px;
      }
      a {
        margin-right: 20px;
        padding: 5px;
        background-color: #73a2e9;
        color: $white !important;
        font-size: 12px !important;
      }
    }
    .st-record {
      width: 90%;
      padding: 10px 5% 60px 5%;
      background-color: #f5f5f5;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      color: #b0b0b0;
    }
  }
}
</style>
